<template>
	<div :class="['app', { 'is-bot': isGoogleBot }, `is-${browser}`]">
		<div v-if="isPreview" class="button-exit-preview">
			<a
				href="#"
				button="primary xsmall"
				class="cta-button"
				@click="exitPreview"
			>
				<div class="button-background"></div>
				<div class="button-text">Quitter le mode preview</div>
			</a>
		</div>

		<WistiaPlayerEmbed />
		<CookieBanner />

		<NuxtLayout>
			<NuxtPage/>
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
import {useIsGoogleBot} from "~~/composables/useIsGoogleBot.js";
import { useDeviceInfo} from "~~/composables/useDeviceInfo.js";
import { usePreview } from '~~/composables/usePreview.js'
import WistiaPlayerEmbed from "~/components/WistiaPlayerEmbed.vue";

const isGoogleBot = useIsGoogleBot();
const { isPreview } = usePreview();

const {locale, t} = useI18n();
const isLoading = ref(true);
const browser = ref('');
let isProd = true;

console.log('isGoogleBot', isGoogleBot);

if(process.env.NOFOLLOW || process.env.NUXT_PUBLIC_BASE_URL && process.env.NUXT_PUBLIC_BASE_URL.includes('dev')) {
	isProd = false;
}

if (import.meta.client) {
	const storedLanguage = localStorage.getItem("nuxt-lang");
	if (storedLanguage && storedLanguage !== "en-CA") {
		locale.value = storedLanguage;
	}
}

const exitPreview = async () => {
	try {
		await $fetch('/api/contentful/exit-preview')
		// Redirection vers la home
		window.location.href = '/'
	} catch (error) {
		console.error('Erreur lors de la sortie du mode preview', error)
	}
}

onMounted(() => {
	// Remove loading state after initial render
	nextTick(() => {
		browser.value = useDeviceInfo().browser;
		isLoading.value = false;
	});
});

useHead({
	htmlAttrs: {
		lang: locale,
		dir: computed(() => {
			return t("locale.dir") as "ltr" | "rtl" | "auto";
		}),
	},
	meta: isProd ? [] :
		[
			{
				name: 'robots',
				content: 'noindex, nofollow',
			},
		],
});
</script>